<template>
  <div class="tariff-contract">
    <div
      v-if="hasContract"
      class="tariff-contract__column tariff-contract__column--num--1"
    >
      <div class="tariff-contract__general-info contract-info">
        <div class="contract-info__props">
          <div class="contract-info__prop contract-prop">
            <div class="contract-prop__key">Статус договора</div>
            <div
              :class="`contract-prop__val contract-prop__val--status--${contractStatus}`"
            >
              {{ statusName }}
            </div>
          </div>

          <div class="contract-info__prop contract-prop">
            <div class="contract-prop__key">Дата заключения</div>
            <div class="contract-prop__val">
              {{ contractStartDate | localDate }}
            </div>
          </div>

          <div class="contract-info__prop contract-prop">
            <div class="contract-prop__key">Тариф</div>
            <div class="contract-prop__val">
              {{ contractTariffName }}
            </div>
          </div>
        </div>

        <img
          src="../../assets/images/contract-cat.svg"
          alt=""
          class="contract-info__image"
        />
      </div>

      <MarginConfirmationBlock
          v-if="contractStatus === 'concluding'"
          class="tariff-contract__confirmation"
      />

      <Documents class="tariff-contract__documents-list" />
    </div>

    <div
      v-if="hasContract"
      class="tariff-contract__column tariff-contract__column--num--2"
    >
      <ContractHistory class="tariff-contract__history">
        <template #title>
          <div class="contract-history__title">История действий</div>
        </template>
      </ContractHistory>
    </div>

    <div v-if="!hasContract" class="tariff-contract-none">
      <div class="tariff-contract-none__icon-wr">
        <AppIcon name="file-clock" class="tariff-contract-none__icon" />
      </div>
      <div class="tariff-contract-none__title">Договор не заключен</div>
      <div class="tariff-contract-none__description">
        Для заключения договора обратитесь к аутсорсеру
      </div>
    </div>
  </div>
</template>

<script>
import { CONTRACT_STATUS_NAMES } from "../../utils/constants";

import { mapGetters } from "vuex";

import AppIcon from "@/components/common/Icon.vue";
import ContractHistory from "../../components/Tariff/ContractHistory.vue";
import Documents from "../../components/Tariff/Documents.vue";
import MarginConfirmationBlock from "@/components/Tariff/MarginConfirmationBlock.vue";

export default {
  name: "TariffContract",

  components: {
    AppIcon,
    ContractHistory,
    Documents,
    MarginConfirmationBlock
  },

  computed: {
    ...mapGetters("Organizations/ActiveOne", [
      "contractTariffName",
      "contractStatus",
      "contractStartDate",
    ]),

    statusName() {
      return CONTRACT_STATUS_NAMES[this.contractStatus];
    },

    /**
     * Есть договор в статусе service(Активен)|suspended(Приостановлен)|terminated(Расторгнут)|concluding(Заключение договора)
     */
    hasContract() {
      return this.contractStatus && this.contractStatus !== "none";
    },
  },
};
</script>

<style scoped lang="scss">
.tariff-contract {
  display: flex;
  flex-wrap: wrap;
  padding: 12px 24px 24px;

  &__contract-offer {
    width: 100%;
  }

  &__column {
    &--num {
      &--1 {
        display: flex;
        width: calc(60% - 20px);
        flex-direction: column;
        margin-right: 20px;
      }

      &--2 {
        width: 40%;
      }
    }
  }

  &__general-info,
  &__documents-list,
  &__history {
    border-radius: 8px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
  }

  &__general-info {
    height: 192px;
    margin-bottom: 20px;
  }

  &__documents-list {
    flex: 1;
  }

  &__history {
    height: 100%;
    padding: 30px;
  }

  &__confirmation {
    margin-bottom: 24px;
  }

  @media (max-width: 1264px) {
    padding: 12px 20px 20px;

    &__history {
      padding: 24px;
    }
  }

  @media (max-width: 960px) {
    &__documents-list {
      margin-bottom: 24px;
    }

    &__column {
      &--num {
        &--1 {
          width: 100%;
          margin-right: 0;
        }

        &--2 {
          width: 100%;
        }
      }
    }
  }

  @media (max-width: 600px) {
    padding: 10px;

    &__general-info {
      height: unset;
    }

    &__general-info,
    &__documents-list,
    &__history {
      border-radius: 8px;
      margin-bottom: 0;
      box-shadow: none;
    }
  }
}

.contract-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 20px 30px;

  &__props {
    display: flex;
  }

  &__image {
    width: 150px;
  }

  @media (max-width: 1904px) {
    &__props {
      flex-direction: column;
    }
  }

  @media (max-width: 1264px) {
    padding: 20px 20px 20px 24px;
  }

  @media (max-width: 600px) {
    &__image {
      display: none;
    }
  }
}

.contract-prop {
  min-width: 190px;

  &__key {
    margin-bottom: 12px;
    color: $grey-700;
  }

  &__val {
    font-weight: 500;

    &--status {
      &--service {
        color: $lime-500;
      }

      &--terminated {
        color: $red-500;
      }

      &--suspended {
        color: #ff9416;
      }
    }
  }

  @media (max-width: 1904px) {
    display: flex;

    &:not(:last-child) {
      margin-bottom: 16px;
    }

    &__key {
      min-width: 160px;
      margin-bottom: unset;
    }

    &__val {
      font-weight: unset;
    }
  }
}

.tariff-contract-none {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &__icon-wr {
    display: flex;
    width: 190px;
    height: 190px;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    margin-bottom: 30px;
    background-color: #ebebeb;
  }

  &__icon {
    color: #b7b7b7;
  }

  &__title {
    margin-bottom: 10px;
    color: #333;
    font-size: 26px;
    font-weight: 500;
    line-height: 34px;
    text-align: center;
  }

  &__description {
    max-width: 400px;
    color: #848484;
    font-size: 18px;
    line-height: 25px;
    text-align: center;
  }
}
</style>
